import favicon from 'assets/favicons/favicon.ico';
import appLogo from 'assets/logos/logo.png';

export const getAppLogo = () => appLogo;

export const setAppFavicon = () => {
  const link = document.createElement('link');
  const oldLink = document.getElementById('dynamic-favicon');

  link.id = 'dynamic-favicon';
  link.rel = 'icon';
  link.href = favicon;

  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
};
